import { TOGGLE_APP_STATE, SIGN_IN, SIGN_OUT } from 'store/AppState/constants'

export const toggleAppState = newState => ({
  payload: newState,
  type: TOGGLE_APP_STATE
})

export const signIn = user => ({
  type: SIGN_IN,
  payload: user
})

export const signOut = () => ({
  type: SIGN_OUT
})
